// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__YeiEB","title":"NotFound_title__wDD9U","text":"NotFound_text__5g9cW","subtext":"NotFound_subtext__zUsNc"};